var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlur1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_162257",
    "data-name": "Groupe 162257",
    transform: "translate(-675 -1441)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_162256",
    "data-name": "Groupe 162256"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_162255",
    "data-name": "Groupe 162255"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_67",
    "data-name": "Trac\\xE9 67",
    d: "M0,0H21V21H0Z",
    transform: "translate(675 1441)",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "blur",
    transform: "translate(676.285 1442.285)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_61",
    "data-name": "Groupe 61"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_60",
    "data-name": "Groupe 60"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_42",
    "data-name": "Trac\\xE9 42",
    d: "M.485,234.667a.485.485,0,1,0,.485.485A.486.486,0,0,0,.485,234.667Z",
    transform: "translate(0 -223.997)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_43",
    "data-name": "Trac\\xE9 43",
    d: "M.485,149.333a.485.485,0,1,0,.485.485A.486.486,0,0,0,.485,149.333Z",
    transform: "translate(0 -142.543)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_44",
    "data-name": "Trac\\xE9 44",
    d: "M149.818,384a.485.485,0,1,0,.485.485A.486.486,0,0,0,149.818,384Z",
    transform: "translate(-142.543 -366.54)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_45",
    "data-name": "Trac\\xE9 45",
    d: "M54.3,53.333a.97.97,0,1,0,.97.97A.973.973,0,0,0,54.3,53.333Z",
    transform: "translate(-50.909 -50.908)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_46",
    "data-name": "Trac\\xE9 46",
    d: "M54.3,138.667a.97.97,0,1,0,.97.97A.973.973,0,0,0,54.3,138.667Z",
    transform: "translate(-50.909 -132.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_47",
    "data-name": "Trac\\xE9 47",
    d: "M54.3,224a.97.97,0,1,0,.97.97A.973.973,0,0,0,54.3,224Z",
    transform: "translate(-50.909 -213.815)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_48",
    "data-name": "Trac\\xE9 48",
    d: "M384.485,150.3a.485.485,0,1,0-.485-.485A.486.486,0,0,0,384.485,150.3Z",
    transform: "translate(-366.54 -142.543)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_49",
    "data-name": "Trac\\xE9 49",
    d: "M235.151.97a.485.485,0,1,0-.485-.485A.486.486,0,0,0,235.151.97Z",
    transform: "translate(-223.996 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_50",
    "data-name": "Trac\\xE9 50",
    d: "M139.637,55.274a.97.97,0,1,0-.97-.97A.973.973,0,0,0,139.637,55.274Z",
    transform: "translate(-132.362 -50.909)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_51",
    "data-name": "Trac\\xE9 51",
    d: "M149.818.97a.485.485,0,1,0-.485-.485A.486.486,0,0,0,149.818.97Z",
    transform: "translate(-142.543 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_52",
    "data-name": "Trac\\xE9 52",
    d: "M224.97,55.274a.97.97,0,1,0-.97-.97A.973.973,0,0,0,224.97,55.274Z",
    transform: "translate(-213.815 -50.909)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_53",
    "data-name": "Trac\\xE9 53",
    d: "M54.3,309.333a.97.97,0,1,0,.97.97A.973.973,0,0,0,54.3,309.333Z",
    transform: "translate(-50.909 -295.268)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_54",
    "data-name": "Trac\\xE9 54",
    d: "M214.788,128a1.455,1.455,0,1,0,1.455,1.455A1.453,1.453,0,0,0,214.788,128Z",
    transform: "translate(-203.633 -122.18)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_55",
    "data-name": "Trac\\xE9 55",
    d: "M310.3,224a.97.97,0,1,0,.97.97A.973.973,0,0,0,310.3,224Z",
    transform: "translate(-295.269 -213.815)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_56",
    "data-name": "Trac\\xE9 56",
    d: "M310.3,309.333a.97.97,0,1,0,.97.97A.973.973,0,0,0,310.3,309.333Z",
    transform: "translate(-295.269 -295.268)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_57",
    "data-name": "Trac\\xE9 57",
    d: "M310.3,138.667a.97.97,0,1,0,.97.97A.973.973,0,0,0,310.3,138.667Z",
    transform: "translate(-295.269 -132.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_58",
    "data-name": "Trac\\xE9 58",
    d: "M384.485,234.667a.485.485,0,1,0,.485.485A.486.486,0,0,0,384.485,234.667Z",
    transform: "translate(-366.54 -223.997)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_59",
    "data-name": "Trac\\xE9 59",
    d: "M310.3,53.333a.97.97,0,1,0,.97.97A.973.973,0,0,0,310.3,53.333Z",
    transform: "translate(-295.269 -50.908)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_60",
    "data-name": "Trac\\xE9 60",
    d: "M129.455,213.333a1.455,1.455,0,1,0,1.455,1.455A1.453,1.453,0,0,0,129.455,213.333Z",
    transform: "translate(-122.18 -203.633)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_61",
    "data-name": "Trac\\xE9 61",
    d: "M139.637,309.333a.97.97,0,1,0,.97.97A.973.973,0,0,0,139.637,309.333Z",
    transform: "translate(-132.362 -295.268)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_62",
    "data-name": "Trac\\xE9 62",
    d: "M129.455,128a1.455,1.455,0,1,0,1.455,1.455A1.453,1.453,0,0,0,129.455,128Z",
    transform: "translate(-122.18 -122.18)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_63",
    "data-name": "Trac\\xE9 63",
    d: "M224.97,309.333a.97.97,0,1,0,.97.97A.973.973,0,0,0,224.97,309.333Z",
    transform: "translate(-213.815 -295.268)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_64",
    "data-name": "Trac\\xE9 64",
    d: "M235.151,384a.485.485,0,1,0,.485.485A.486.486,0,0,0,235.151,384Z",
    transform: "translate(-223.996 -366.54)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_65",
    "data-name": "Trac\\xE9 65",
    d: "M214.788,213.333a1.455,1.455,0,1,0,1.455,1.455A1.453,1.453,0,0,0,214.788,213.333Z",
    transform: "translate(-203.633 -203.633)",
    fill: "#fff"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlur1);
export default __webpack_public_path__ + "static/media/blur1.aade320e6aa5b1384640c1ce59cd10c4.svg";
export { ForwardRef as ReactComponent };